import { InjectionToken } from '@angular/core';

import { SheetContent } from './sheet.service';

export const SHEET_CONTENT_DATA = new InjectionToken<SheetContent>('SHEET_CONTENT_DATA');
